
export default {
	name: "InputField",
	model: {
		prop: "value",
		event: "input",
	},
	props: {
		value: {
			required: true,
			type: [String, Number],
		},
		stepperStyle: {
			required: false,
			type: Boolean,
			default: false,
		},
		block: {
			required: false,
			type: Boolean,
			default: false,
		},
		valueMiddleware: {
			required: false,
			type: Function,
			default: (v) => v,
		},
		id: {
			required: false,
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			localValue: this.value,
		};
	},
	watch: {
		value(newVal) {
			this.localValue = newVal;
		},
	},
	methods: {
		onBlur() {
			if (this.stepperStyle) {
				this.updateValue();
			}
		},
		onInput() {
			if (!this.stepperStyle) {
				this.updateValue();
			}
		},
		async updateValue() {
			let val = this.$el.value;
			val =
				typeof this.valueMiddleware === "function"
					? this.valueMiddleware(val)
					: val;

			this.$emit("input", val);
			await this.$nextTick();
			this.$el.value = val;
		},
	},
};
